export default "__VITE_ASSET__eodr8rE8__"